import React from "react";

export const Inhalator = () => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="15px"
      height="15px"
      viewBox="0 0 59 59"
    >
      <g>
        <circle cx="50" cy="50.952" r="1" />
        <circle cx="54" cy="50.952" r="1" />
        <circle cx="58" cy="50.952" r="1" />
        <circle cx="50" cy="46.952" r="1" />
        <circle cx="54" cy="46.952" r="1" />
        <circle cx="58" cy="46.952" r="1" />
        <circle cx="50" cy="54.952" r="1" />
        <circle cx="54" cy="54.952" r="1" />
        <circle cx="58" cy="54.952" r="1" />
        <path
          d="M9.935,5.13L4.113,6.581C3.578,6.715,3.251,7.258,3.384,7.793c0.113,0.455,0.521,0.758,0.97,0.758
		c0.08,0,0.162-0.009,0.243-0.03l5.822-1.452c0.535-0.133,0.861-0.676,0.729-1.212C11.014,5.322,10.47,4.993,9.935,5.13z"
        />
        <path
          d="M13.817,4.162l-0.971,0.242c-0.536,0.133-0.862,0.676-0.729,1.212c0.113,0.455,0.521,0.758,0.97,0.758
		c0.08,0,0.161-0.009,0.242-0.03l0.971-0.242c0.536-0.133,0.862-0.676,0.729-1.212C14.895,4.355,14.352,4.027,13.817,4.162z"
        />
        <path
          d="M29.565,40.92L21.25,9.238l-1.805,0.961L17.57,2.682c-0.225-0.9-0.786-1.659-1.581-2.136
		c-0.795-0.478-1.728-0.618-2.628-0.393L2.634,2.828c-0.9,0.224-1.659,0.786-2.137,1.581S-0.12,6.137,0.104,7.036L3.067,18.92
		l-1.83,0.975l9.979,37.539c0.237,0.894,1.049,1.519,1.975,1.519H47v-18H29.606C29.586,40.952,29.57,40.939,29.565,40.92z
		 M4.886,17.951L2.045,6.553C1.95,6.171,2.009,5.776,2.211,5.438c0.202-0.337,0.524-0.575,0.906-0.67l10.728-2.675
		c0.118-0.029,0.238-0.044,0.358-0.044c0.264,0,0.523,0.071,0.755,0.211c0.337,0.202,0.575,0.524,0.67,0.906l1.996,8.002
		l-4.747,2.528L4.886,17.951z M45,56.952L13.149,56.92L3.577,20.915L19.943,12.2l0,0l0.014-0.007l7.674,29.236
		c0.235,0.897,1.048,1.524,1.976,1.524H45V56.952z"
        />
        <path d="M25,40.952h-4c-0.553,0-1,0.448-1,1s0.447,1,1,1h4c0.553,0,1-0.448,1-1S25.553,40.952,25,40.952z" />
        <path
          d="M17.291,41.242c-0.181,0.19-0.29,0.45-0.29,0.71c0,0.26,0.109,0.52,0.29,0.71c0.189,0.18,0.45,0.29,0.71,0.29
		s0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71C18.331,40.872,17.661,40.872,17.291,41.242z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
